import {useQuery} from "react-query";
import * as api from "../api/easeedesk/apis";

const getAttachments = async (ticketId) => {
    return await api.fetchTicketAttachments(ticketId);
};

export default function useTickets(ticketId) {
    return useQuery(['ticket_attachments', {ticketId}], () => getAttachments(ticketId), {refetchOnWindowFocus: false});
}
